var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-group_6 flex-col"},[_c('span',{staticClass:"text_49"},[_vm._v("CoreTrust Phone @2024~2030")]),_c('span',{staticClass:"text_50"},[_vm._v(_vm._s(_vm.$t('base_on')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }